<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"
      @clickHandler="item.clickHandler()"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "ManageSquadHeader",
  props: ["title"],
  components: {
    HeaderValues,
  },
  computed: {
    items() {
      return [
        {
          layout: "left-side",
          icon: {
            path: require("@/assets/logos/BackBtn@3x.png").default,
          },
          clickHandler: () => {
            this.$router.go(-1)
          },
        },
        {
          title: this.title,
          layout: "middle",
        },
      ]
    },
  },
}
</script>

<style scoped lang="sass"></style>
